<h2 mat-dialog-title class="text-center">
  <span class="text-white">Generar resumen</span>
  <button mat-icon-button type="button" aria-label="Cerrar" class="dialog-close top-0 right-0" (click)="onCancel()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content>
  <p class="mb-3">Selecciona cómo quieres agrupar el resumen para la liquidación semana {{data.liquidation.week}} / {{data.liquidation.year}}.</p>

  <mat-form-field appearance="fill" floatLabel="always" class="w-full mb-4">
    <mat-label>Tipo de reporte</mat-label>
    <mat-select [(ngModel)]="reportType">
      <mat-option value="integrated">Integrado</mat-option>
      <mat-option value="bank_file">Archivo para Bancos</mat-option>
      <mat-option value="invoice_reconciliation">Cuadre de facturas</mat-option>
      <mat-option value="liquidation_by_route">Liquidación por ruta</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-radio-group [(ngModel)]="grouping" class="flex flex-col gap-2">
    <mat-radio-button value="partner">Por cliente</mat-radio-button>
    <mat-radio-button value="entity">Por cliente-entidad</mat-radio-button>
    <mat-radio-button value="route">Por cliente-ruta</mat-radio-button>
    <mat-radio-button value="partner_entity_route">Por cliente-entidad-ruta</mat-radio-button>
    <mat-radio-button value="bus">Por bus</mat-radio-button>
  </mat-radio-group>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button color="primary" (click)="onConfirm()">Generar Excel</button>
</mat-dialog-actions>
